/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_GrammarInputs */

const en_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grammar/Spelling`)
};

const fr_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grammaire/orthographe`)
};

const de_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grammatik/Rechtschreibung`)
};

const it_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grammatica/Ortografia`)
};

const ru_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грамматика/орфография`)
};

const es_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gramática/Ortografía`)
};

const zh_cn2_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语法/拼写`)
};

const ja_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文法/スペル`)
};

const hi_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्याकरण/वर्तनी`)
};

const pt_pt2_manual_qc_type_grammar = /** @type {(inputs: Manual_Qc_Type_GrammarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gramática/Ortografia`)
};

/**
* | output |
* | --- |
* | "Grammar/Spelling" |
*
* @param {Manual_Qc_Type_GrammarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_grammar = /** @type {((inputs?: Manual_Qc_Type_GrammarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_GrammarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_grammar(inputs)
	if (locale === "de") return de_manual_qc_type_grammar(inputs)
	if (locale === "it") return it_manual_qc_type_grammar(inputs)
	if (locale === "ru") return ru_manual_qc_type_grammar(inputs)
	if (locale === "es") return es_manual_qc_type_grammar(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_grammar(inputs)
	if (locale === "ja") return ja_manual_qc_type_grammar(inputs)
	if (locale === "hi") return hi_manual_qc_type_grammar(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_grammar(inputs)
	return en_manual_qc_type_grammar(inputs)
});